<template>
    <Head>
        <title>Organization</title>
    </Head>

    <authenticated-layout :notifications="notifications" >

        <template #header>
            <user-navigation v-if="userId" :user-id="userId" />
            <navigation v-if="organizationId" :organization-id="organizationId"/>
        </template>


        <form
            class="p-6 flex flex-col bg-white"
            method="post"
            @submit.prevent="send"
            @change="change"
        >

            <div v-if="result" class="flex flex-col gap-2">

                <div class="grid grid-cols-3 items-center gap-6">
                    <span class="text-right text-sm text-gray-700">ID</span>
                    <div>{{ result.id }}</div>
                </div>

                <div class="grid grid-cols-3 items-center gap-6">
                    <span class="text-right text-sm text-gray-700">Название</span>
                    <div>{{ result.name }}</div>
                    <v-input v-model="form.name" :error="errors.name" v-if="access('organizations', 'editable')"/>
                </div>

                <div class="grid grid-cols-3 items-center gap-6" v-if="this.$page.props.auth.user.role !== 'aml'">
                    <span class="text-right text-sm text-gray-700">Внутренняя</span>
                    <svg :class="result.internal ? 'text-green-400' : 'text-red-400'" class="fill-current h-6 w-6" viewBox="0 0 16 16">
                        <path v-if="result.internal"
                              d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"/>
                        <path v-else
                              d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                    </svg>
                    <v-toggle @change="change" v-model="form.internal" :error="errors.internal" v-if="access('organizations', 'editable')"/>
                </div>

                <div class="grid grid-cols-3 items-center gap-6">
                    <span class="text-right text-sm text-gray-700">Внутреннее название</span>
                    <div>{{ result.internalName }}</div>
                    <v-input v-model="form.internalName" :error="errors.internalName" v-if="access('organizations', 'editable')"/>
                </div>

                <div class="grid grid-cols-3 items-center gap-6">
                    <span class="text-right text-sm text-gray-700">Внутренний комментарий</span>
                    <div>{{ result.internalComment }}</div>
                    <v-input v-model="form.internalComment" :error="errors.internalComment" v-if="access('organizations', 'editable')"/>
                </div>

                <div class="grid grid-cols-3 items-center gap-6" v-if="this.$page.props.auth.user.role !== 'aml'">
                    <span class="text-right text-sm text-gray-700">AML</span>
                    <svg :class="result.aml ? 'text-green-400' : 'text-red-400'" class="fill-current h-6 w-6" viewBox="0 0 16 16">
                        <path v-if="result.aml"
                              d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"/>
                        <path v-else
                              d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                    </svg>
                    <v-toggle @change="change" v-model="form.aml" :error="errors.aml" v-if="access('organizations', 'editable')"/>
                </div>

                <div class="grid grid-cols-3 items-center gap-6">
                    <span class="text-right text-sm text-gray-700">Проверка рисков</span>
                    <svg :class="result.checkTrx ? 'text-green-400' : 'text-red-400'" class="fill-current h-6 w-6" viewBox="0 0 16 16">
                        <path v-if="result.checkTrx"
                              d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"/>
                        <path v-else
                              d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                    </svg>
                    <v-toggle @change="change" v-model="form.checkTrx" :error="errors.checkTrx" v-if="access('organizations', 'editable')"/>
                </div>

                <div class="grid grid-cols-3 items-center gap-6">
                    <span class="text-right text-sm text-gray-700">Минимальная сумма для проверки</span>
                    <div>{{ result.checkTrxMinAmount }}</div>
                    <v-input v-model="form.checkTrxMinAmount" :error="errors.checkTrxMinAmount" v-if="access('organizations', 'editable')"/>
                </div>

                <div class="grid grid-cols-3 items-center gap-6">
                    <span class="text-right text-sm text-gray-700">KYC</span>
                    <svg :class="result.kycApprove ? 'text-green-400' : 'text-red-400'" class="fill-current h-6 w-6" viewBox="0 0 16 16">
                        <path v-if="result.kycApprove"
                              d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"/>
                        <path v-else
                              d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                    </svg>
                    <v-toggle @change="change" v-model="form.kycApprove" :error="errors.kycApprove" v-if="access('organizations', 'editable')"/>
                </div>

                <div class="grid grid-cols-3 items-center gap-6">
                    <span class="text-right text-sm text-gray-700">Reccurent</span>
                    <svg :class="result.allowRecurrent ? 'text-green-400' : 'text-red-400'" class="fill-current h-6 w-6" viewBox="0 0 16 16">
                        <path v-if="result.allowRecurrent" d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"/>
                        <path v-else d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                    </svg>
                    <v-toggle @change="change" v-model="form.allowRecurrent" :error="errors.allowRecurrent" v-if="access('organizations', 'editable')"/>
                </div>

                <div class="grid grid-cols-3 items-center gap-6">
                    <span class="text-right text-sm text-gray-700">Free Payment</span>
                    <svg :class="result.allowFreePayment ? 'text-green-400' : 'text-red-400'" class="fill-current h-6 w-6" viewBox="0 0 16 16">
                        <path v-if="result.allowFreePayment" d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"/>
                        <path v-else d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                    </svg>
                    <v-toggle @change="change" v-model="form.allowFreePayment" :error="errors.allowFreePayment" v-if="access('organizations', 'editable')"/>
                </div>

                <div class="grid grid-cols-3 items-center gap-6" v-if="this.$page.props.auth.user.role !== 'aml'">
                    <span class="text-right text-sm text-gray-700">Хост</span>
                    <div>{{ result.host }}</div>
                    <div class="flex flex-row gap-2" v-if="access('organizations', 'editable')">
                        <v-select v-model="form.host">
                            <option></option>
                            <option :value="host" v-for="host in hosts">{{ host }}</option>
                        </v-select>
                        <v-input v-model="form.host" :error="errors.host"/>
                    </div>
                </div>

                <div class="grid grid-cols-3 items-center gap-6">
                    <span class="text-right text-sm text-gray-700">Orphan Webhook Url</span>
                    <div>{{ result.orphanWebhookUrl }}</div>
                    <v-input v-model="form.orphanWebhookUrl" :error="errors.orphanWebhookUrl" v-if="access('organizations', 'editable')"/>
                </div>

                <div class="grid grid-cols-3 items-center gap-6">
                    <span class="text-right text-sm text-gray-700">Разрешение доступа к кроссчейн обменам</span>
                    <svg :class="result.allowCrosschainSwaps ? 'text-green-400' : 'text-red-400'" class="fill-current h-6 w-6" viewBox="0 0 16 16">
                        <path v-if="result.allowCrosschainSwaps" d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"/>
                        <path v-else d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                    </svg>
                    <v-toggle @change="change" v-model="form.allowCrosschainSwaps" :error="errors.allowCrosschainSwaps" v-if="access('organizations', 'editable')"/>
                </div>

                <div class="grid grid-cols-3 items-center gap-6">
                    <span class="text-right text-sm text-gray-700">Разрешение доступа к кроссчейн трансферам</span>
                    <svg :class="result.allowCrosschainTransfers ? 'text-green-400' : 'text-red-400'" class="fill-current h-6 w-6" viewBox="0 0 16 16">
                        <path v-if="result.allowCrosschainTransfers" d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"/>
                        <path v-else d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                    </svg>
                    <v-toggle @change="change" v-model="form.allowCrosschainTransfers" :error="errors.allowCrosschainTransfers" v-if="access('organizations', 'editable')"/>
                </div>

                <div class="grid grid-cols-3 items-center gap-6">
                    <span class="text-right text-sm text-gray-700">Группа опер аккаунтов</span>
                    <div>{{ result.operGroup === null ? 'default group' : result.operGroup }}</div>
                    <v-select v-model="form.operGroup" :error="errors.operGroup" v-if="access('organizations', 'editable')">
                        <option :value="null" >default group</option>
                        <option :value="group" v-for="group in operGroups.filter(g => g !== 'default group')">{{ group }}</option>
                    </v-select>
                </div>

                <div class="grid grid-cols-3 items-center gap-6">
                    <span class="text-right text-sm text-gray-700">Группа бирж</span>
                    <div>{{ result.exchangeGroup }}</div>
                    <v-select v-model="form.exchangeGroup" :error="errors.exchangeGroup" v-if="access('organizations', 'editable')">
                        <option value="null">Не использовать</option>
                        <option :value="group" v-for="group in exchangeGroups">{{ group }}</option>
                    </v-select>
                </div>

                <div class="grid grid-cols-3 items-center gap-6">
                    <span class="text-right text-sm text-gray-700">Минимальная сумма на адресе для сбора (эквивалент в USD)</span>
                    <div>{{ result.collectingMinimumAmount }}</div>
                    <v-input v-model="form.collectingMinimumAmount" :error="errors.collectingMinimumAmount"
                             v-if="access('organizations', 'editable')"/>
                </div>

                <div class="grid grid-cols-3 items-center gap-6">
                    <span class="text-right text-sm text-gray-700">Интервал между сборами (в днях)</span>
                    <div>{{ result.collectingInterval }}</div>
                    <v-input v-model="form.collectingInterval" :error="errors.collectingInterval"
                             v-if="access('organizations', 'editable')"/>
                </div>

                <div class="grid grid-cols-3 items-center gap-6">
                    <span class="text-right text-sm text-gray-700">Дата следующего сбора на головные адреса (UTC)</span>
                    <div>{{ result.nextCollectingAt }}</div>
                    <v-input v-model="form.nextCollectingAt" type="datetime-local" :error="errors.nextCollectingAt"
                             v-if="access('organizations', 'editable')"/>
                </div>

                <div class="grid grid-cols-3 items-center gap-6">
                    <span class="text-right text-sm text-gray-700">Создана</span>
                    <div>{{ result.createdAt ? moment(result.createdAt).utc().format('L LTS') : '' }}</div>
                </div>

                <div class="grid grid-cols-3 items-center gap-6">
                    <span class="text-right text-sm text-gray-700">Обновлена</span>
                    <div>{{ result.updatedAt ? moment(result.updatedAt).utc().format('L LTS') : ''}}</div>
                    <v-button :disabled="disableSend"  v-if="access('organizations', 'editable')">
                        {{ organizationId ? 'Изменить' : 'Создать' }}
                    </v-button>
                </div>

            </div>

        </form>

        <form
            method="post"
            v-if="recurentMerchants && recurentMerchantLoad"
            @change="recurentMerchantsUpdated = true"
            @submit.prevent="updateRecurentMerchants"
            class="grid grid-cols-4 gap-6 p-6 mt-4 bg-white"
        >
            <v-select label="Минимальный период списания по подписке" v-model="recurentMerchants.minSpendInterval">
                <option>2_MINUTES</option>
                <option>15_MINUTES</option>
                <option>HOUR</option>
                <option>DAY</option>
                <option>WEEK</option>
                <option>MONTH</option>
            </v-select>
            <v-input label="Максимальное списание за раз" v-model="recurentMerchants.maxSpendAmountUSD"/>
            <v-input label="Лимит по всем списаниям в месяц" v-model="recurentMerchants.maxMonthSpendAmountUSD"/>
            <v-input label="Сумма апрува" v-model="recurentMerchants.approveAmountUSD"/>
            <v-button class="col-start-4" :disabled="!recurentMerchantsUpdated">Обновить</v-button>
        </form>
        <v-spinner v-else-if="!recurentMerchantLoad" class="h-16 w-16 mx-auto"/>

    </authenticated-layout>

</template>

<script>
import {Head, Link, useForm} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated';
import Navigation from "@/Components/Navigation/Organization";
import UserNavigation from "@/Components/Navigation/User";
import VInput from  "@/Components/Input";
import VButton from "@/Components/Button";
import VSelect from "@/Components/Select";
import VToggle from "@/Components/Toggle";
import VSpinner from "@/Components/Spinner";
import moment from "moment";
import {reactive} from "vue";

export default {
    components: {
        Head, Link,
        AuthenticatedLayout,
        Navigation,
        UserNavigation,
        VInput,
        VButton,
        VSelect,
        VToggle,
        VSpinner,
    },
    props: {
        success: Boolean,
        errors: Object,
        result: Object,
        hosts: Array,
        notifications: Array,
        organizationId: String,
        userId: String,
        exchangeGroups: Array,
        operGroups: Array,
    },
    data() {
        return {
            disableSend: true,
            changes: {},
            recurentMerchants: null,
            recurentMerchantLoad: false,
            recurentMerchantsUpdated: false,
        }
    },
    setup(props) {
        const form = reactive({...props.result});
        return {form};
    },
    mounted() {
        if(this.organizationId && this.access('organizations', 'editable')) {
            axios.get(this.route('organization.get-recurrent-merchants', this.organizationId))
                .then((res) => {
                    const {success, result, notifications} = res.data;
                    this.recurentMerchantLoad = success;
                    if (success)
                        this.recurentMerchants = result[0];
                    this.notifications.push(...notifications);
                });
        } else this.recurentMerchantLoad = true;
    },
    methods: {
        moment,
        send() {
            this.disableSend = true;
            if(this.organizationId) {
                axios.post(this.route('organization.update', this.organizationId), this.changes)
                    .then((res) => {
                        const {success, result, notifications} = res.data;
                        if (success)
                            for (const i in result) {
                                this.form[i] = result[i];
                                this.result[i] = result[i];
                            }
                        if(notifications)
                            this.notifications.push(...notifications);
                    });
            } else {
                useForm(this.form).post(this.route('organization.create', this.userId));
            }
        },
        updateRecurentMerchants() {
            this.recurentMerchantsUpdated = false;
            const {id, minSpendInterval, maxSpendAmountUSD, maxMonthSpendAmountUSD, approveAmountUSD} = this.recurentMerchants
            axios.post(this.route('organization.update-recurrent-merchant'), {
                merchantId: id,
                minSpendInterval,
                maxSpendAmountUSD,
                maxMonthSpendAmountUSD,
                approveAmountUSD,
            }).then((res) => {
                const {success, result, notifications} = res.data;
                if(success)
                    this.recurentMerchants = result;
                this.notifications.push(...notifications);
            });
        },
        change() {
            const data = this.result;
            const form = this.form;

            for(const i in form) {
                if (form[i] !== data[i]) {
                    this.changes[i] = form[i];
                } else {
                    if(this.changes.hasOwnProperty(i))
                        delete this.changes[i];
                }
                this.disableSend = Object.keys(this.changes).length === 0;
            }
        },
    },
}
</script>
